module.exports = __webpack_public_path__ + "static/img/EXCELLO.d24593d2.png";